import React, {PropTypes} from 'react';
function AssessmentBank(props) {
  const {
    style: {
      color,
      backgroundColor
    } = {}
  } = props;

  return (
    <svg width="67px" height="67px" viewBox="0 0 67 67" version="1.1" xmlns="http://www.w3.org/2000/svg" >

<title>30DCED96-9D1E-4C4E-B0D9-F7F13D3A664C</title>
  <desc>Created with sketchtool.</desc>
  <defs></defs>
  <g id="501---Assesments" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
  <g transform="translate(-1041.000000, -453.000000)" id="Group-7" fill="#333333">
  <g transform="translate(971.000000, 405.000000)">
  <g id="icon_bank" transform="translate(70.000000, 48.000000)">
  <g id="Icons">
  <g id="Group">
  <path d="M63.842625,67 L3.157375,67 C1.41746875,67 0,65.5825313 0,63.842625 L0,57.5969688 C0,55.8549687 1.41746875,54.4375 3.157375,54.4375 L63.8405313,54.4375 C65.5825313,54.4375 67,55.8549687 67,57.594875 L67,63.8405312 C67,65.5825313 65.5825313,67 63.842625,67 L63.842625,67 Z M4.1875,62.8125 L62.8125,62.8125 L62.8125,58.625 L4.1875,58.625 L4.1875,62.8125 L4.1875,62.8125 Z" id="Shape"></path>
  <path d="M63.859375,20.9375 L3.140625,20.9375 C1.40909375,20.9375 0,19.5660938 0,17.8827188 L0,12.1919063 C0,10.845625 0.88775,9.673125 2.2068125,9.2753125 L33.1712813,0 L34.4338125,0.0879375 L64.7910938,9.21459375 C66.11225,9.61659375 67,10.7890938 67,12.135375 L67,17.8827188 C67,19.5660938 65.5909063,20.9375 63.859375,20.9375 L63.859375,20.9375 Z M4.1875,16.75 L62.8125,16.75 L62.8125,12.9959062 L33.4811563,4.1875 L4.1875,13.0503437 L4.1875,16.75 L4.1875,16.75 Z" id="Shape"></path>
  <path d="M16.33125,52.34375 L8.79375,52.34375 C7.40978125,52.34375 6.28125,51.2152187 6.28125,49.83125 L6.28125,25.54375 C6.28125,24.1597812 7.40978125,23.03125 8.79375,23.03125 L16.33125,23.03125 C17.7152187,23.03125 18.84375,24.1597812 18.84375,25.54375 L18.84375,49.83125 C18.84375,51.2152187 17.7152187,52.34375 16.33125,52.34375 L16.33125,52.34375 Z M10.46875,48.15625 L14.65625,48.15625 L14.65625,27.21875 L10.46875,27.21875 L10.46875,48.15625 L10.46875,48.15625 Z" id="Shape"></path>
  <path d="M37.26875,52.34375 L29.73125,52.34375 C28.3451875,52.34375 27.21875,51.2152187 27.21875,49.83125 L27.21875,25.54375 C27.21875,24.1576875 28.3472813,23.03125 29.73125,23.03125 L37.26875,23.03125 C38.6548125,23.03125 39.78125,24.1597812 39.78125,25.54375 L39.78125,49.83125 C39.78125,51.2152187 38.6527188,52.34375 37.26875,52.34375 L37.26875,52.34375 Z M31.40625,48.15625 L35.59375,48.15625 L35.59375,27.21875 L31.40625,27.21875 L31.40625,48.15625 L31.40625,48.15625 Z" id="Shape"></path>
  <path d="M58.20625,52.34375 L50.66875,52.34375 C49.2826875,52.34375 48.15625,51.2152187 48.15625,49.83125 L48.15625,25.54375 C48.15625,24.1576875 49.2847813,23.03125 50.66875,23.03125 L58.20625,23.03125 C59.5923125,23.03125 60.71875,24.1597812 60.71875,25.54375 L60.71875,49.83125 C60.71875,51.2152187 59.5902187,52.34375 58.20625,52.34375 L58.20625,52.34375 Z M52.34375,48.15625 L56.53125,48.15625 L56.53125,27.21875 L52.34375,27.21875 L52.34375,48.15625 L52.34375,48.15625 Z" id="Shape"></path>
  </g>
  </g>
  </g>
  </g>
  </g>
  </g>
  </svg>
  );
}

AssessmentBank.propTypes = {
  style: PropTypes.object
};

export default AssessmentBank;



// WEBPACK FOOTER //
// ./shared/common/svgs/AssessmentBank.js